import clsx from "clsx";
import { Loader2 } from "lucide-react";
import { PublishStatus } from "common/constants";
import type { SidebarRailButtonProps } from "./types";

export const SidebarRailButton = ({
  item,
  position,
  isSelected,
  isPending,
  onClick,
}: SidebarRailButtonProps) => {
  const isUnpublished = item.publishStatus === PublishStatus.UNPUBLISHED;

  return (
    <button
      type="button"
      onClick={() => onClick(item)}
      className={clsx(
        "w-6 h-6 rounded text-xs font-medium flex items-center justify-center transition-colors",
        isSelected
          ? isUnpublished
            ? "bg-amber-500 text-white"
            : "bg-blue-600 text-white"
          : isUnpublished
            ? "bg-amber-100 text-amber-700 hover:bg-amber-200"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200",
      )}
      title={
        item.sourceFile ? `${item.sourceFile} / ${item.label}` : item.label
      }
    >
      {isPending ? (
        <Loader2 size={12} className="animate-spin" />
      ) : (
        position + 1
      )}
    </button>
  );
};
